import { FieldErrors, FieldValues } from 'react-hook-form'
import { StepLabel } from '@mui/material'

import { StepError } from '@gantt/components/GanttCreateOrEdit/components/GanttConfiguration/components/StepWrap/StepError'

interface IProps<T extends FieldValues> {
  label: string
  errors: FieldErrors<T>
  onClick: () => void
  getIsStepFailed: (stepLabel: string, errors: FieldErrors<T>) => boolean
  getStepErrorFields: (stepLabel: string, errors: FieldErrors<T>) => (string | undefined)[]
}

export const StepLabelWrap = <T extends FieldValues>({
  label,
  errors,
  onClick,
  getIsStepFailed,
  getStepErrorFields,
}: IProps<T>) => {
  const isStepFailed = getIsStepFailed(label, errors)

  return (
    <StepLabel
      error={isStepFailed}
      icon={' '}
      sx={{ cursor: 'pointer' }}
      optional={
        isStepFailed && <StepError errors={getStepErrorFields(label, errors)} label={label} />
      }
      onClick={onClick}
    >
      {label}
    </StepLabel>
  )
}
